import React, { useEffect, useState } from "react";
import "./HeroSection.scss";
import { BsDiscord } from "react-icons/bs";
import { AiOutlineLogin } from "react-icons/ai";
import ScrollDown from "../../../components/ScrollDown/ScrollDown";
import { TypeAnimation } from "react-type-animation";
import { heroData } from "../../../utils/config/landingPageConfig";
import History from "../../../utils/services/GlobalNavigation/navigationHistory";
import { LoginDialog } from "../../../dialogs";


interface HeroSectionProps {
  setLoginDialog: (value: boolean) => void;
  cosmoskitDialog?: any; loginRediect: string;

}

const HeroSection: React.FC<HeroSectionProps> = ({
  setLoginDialog,
  loginRediect,
  cosmoskitDialog
}) => {
  const [typingStatus, setTypingStatus] = useState('Initializing');

  useEffect(() => {
    // console.log(typingStatus,'typingStatus');
  
 
  }, [typingStatus])
  

  return (
    <div className="HeroSection">
      <div className="HeroSection__sideBar">
        <img
          src="/LighthouseLogo.svg"
          alt="lighthouseLogo"
          height={"70px"}
          width={"auto"}
          className="ptr"
          onClick={() => {
            History.push("/");
          }}
        />
        <div className="mascotContainer">
          <div className="mascotSection">
            <img src={`/mascot/${typingStatus}.png`} alt="mascot" />
          </div>
        </div>
        <div className="title">
          <span style={{ fontSize: "2em" }}>
            <TypeAnimation
             sequence={[
              () => setTypingStatus('hacker'),
              'Encryption so tight, even I can’t peek—and I’m you.',
              8000,
              () => setTypingStatus('lifeguard'),
              'Not just guarding—I’m saving your files from bad servers.',
              8000,
              () => setTypingStatus('space'),
              'No lag, just lift-off.',
              8000,
            ]}
            omitDeletionAnimation={true}
              wrapper="span"
              cursor={true}
              repeat={Infinity}
            
            />
          </span>
          <p
            dangerouslySetInnerHTML={{
              __html: heroData.fixedTitle
            }}
          />
          <div className="title__iconContainer">
            <a href={heroData?.discordLink} target="_blank" rel="noreferrer">
              {" "}
              <BsDiscord />
            </a>
            <a href={heroData?.twitterLink} target="_blank" rel="noreferrer">
              {" "}
              <span>
                <img src="/icons/twitterX.svg" alt="icon" width={"20px"} />
              </span>
            </a>
          </div>
        </div>
      </div>
      <div className="HeroSection__loginBar">
        <LoginDialog loginRediect={loginRediect}
          setLoginDialog={setLoginDialog}
          cosmoskitDialog={cosmoskitDialog} />
      </div>
    </div>
  );
};

export default HeroSection;
